import maskInput from 'vanilla-text-mask';
import select2 from 'select2'; // eslint-disable-line no-unused-vars

export default class InsuranceChecker {
  constructor() {
    this.initializeBirthdateField();
    this.initializePayersSelect();
    this.validateFormSubmission();
  }

  initializeBirthdateField() {
    let birthdateInput = document.querySelector('.insurance-eligibility-checker .input-birthdate');

    if (birthdateInput == null) {
      return;
    }

    const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    maskInput({
      inputElement: birthdateInput,
      mask: dateMask,
      guide: false
    });
  }

  initializePayersSelect() {
    $('.chosen-select').select2();
  }

  validateFormSubmission() {
    const form = document.querySelector("[data-js-insurance-check-form]");
    const submitButton = document.querySelector("[data-js-check-submit]");

    const fields = [
      {
        input: document.querySelector("[data-js-check-memberid]"),
        name: "member-id",
        message: "Member ID can't be blank"
      },
      {
        input: document.querySelector("[data-js-check-dob]"),
        name: "birth-date",
        message: "Date of Birth can't be blank"
      },
      {
        input: document.querySelector("[data-js-check-carrier]"),
        name: "carrier",
        message: "Please select an Insurance Company"
      }
    ];

    if (!form || !submitButton || fields.some(f => !f.input)) return;

    let hasSubmitted = false;

    const removeError = ({ input, name }) => {
      const existingError = document.querySelector(`[data-js-error-${name}]`);
      if (existingError) existingError.remove();
    };

    const showError = ({ input, name, message }) => {
      if (!document.querySelector(`[data-js-error-${name}]`)) {
        const errorMessage = document.createElement("span");
        errorMessage.className = "error-message";
        errorMessage.setAttribute(`data-js-error-${name}`, true);
        errorMessage.setAttribute("role", "alert");
        errorMessage.textContent = message;

        const isSelect2 = input.classList.contains("chosen-select");
        const insertAfterEl =
          isSelect2 && input.nextElementSibling?.classList.contains("select2")
          ? input.nextElementSibling
          : input;

        insertAfterEl.parentNode.insertBefore(errorMessage, insertAfterEl.nextSibling);
      }
    };

    const validateFields = () => {
      let hasErrors = false;

      fields.forEach(field => {
        const value = field.input.value.trim();
        if (value === "") {
          if (hasSubmitted) {
            showError(field);
          }
          hasErrors = true;
        } else {
          removeError(field);
        }
      });

      return !hasErrors;
    };

    form.addEventListener("submit", (e) => {
      hasSubmitted = true;
      submitButton.disabled = true;

      const isValid = validateFields();

      if (!isValid) {
        e.preventDefault();
      }
    });

    const revalidate = () => {
      const isValid = validateFields();
      if (isValid) { submitButton.disabled = false; }
    };

    fields.forEach(field => {
      const isCarrierSelect = field.input.classList.contains("chosen-select");

      if (isCarrierSelect) {
        $(field.input).on("select2:select", revalidate);
      } else {
        field.input.addEventListener("input", revalidate);
      }
    });
  }
}
